(() => {
  const roots = document.querySelectorAll('[data-tt-contact-support]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const topic = root.querySelector('[data-tt-contact-topic-select]');
    const form = root.querySelector('#ContactForm');
    if (!topic || !form) return;

    root.querySelectorAll('[data-tt-contact-topic]').forEach((button) => {
      button.addEventListener('click', () => {
        const value = button.getAttribute('data-tt-contact-topic');
        if (value) {
          topic.value = value;
          topic.dispatchEvent(new Event('change', { bubbles: true }));
        }
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => topic.focus({ preventScroll: true }), 350);
      });
    });
  });
})();
